import"react";const n=(n,r)=>{var o;return n.isFetching?r.onPending():n.isSuccess?"isEmpty"in r&&r.isEmpty(n.data)?(null!==(o=r.onEmpty)&&void 0!==o?o:r.onPending)():r.onSuccess(n.data):n.isError&&r.onError?r.onError(n.error):r.onPending()};export{n as select};
//# sourceMappingURL=queries.js.map
